import { createText, createLine } from './helpers';

export const modernAchievement = () => ({
  id: 'modern-achievement',
  name: 'Modern Achievement',
  thumbnail: '/assets/diploma-templates/08_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 147,
        top: 363,
        fontSize: 72,
        fontFamily: 'Cinzel',
        width: 500,
        fontWeight: 'bold',
        color: '#080b10'
      }),
      createText({
        text: 'OF ACHIEVEMENT',
        left: 247,
        top: 447,
        fontSize: 20,
        fontFamily: 'Raleway',
        width: 300,
        color: '#080b10'
      }),
      createLine({ left: 171, top: 500, width: 453 }),
      createText({
        text: 'THIS CERTIFICATE PRESENTED TO',
        left: 222,
        top: 538,
        fontSize: 13,
        fontFamily: 'Raleway',
        width: 350,
        color: '#999999'
      }),
      createText({
        text: '{learner_name}',
        left: 47,
        top: 603,
        fontSize: 53,
        fontFamily: 'Great Vibes',
        width: 700,
        color: '#386d9e'
      }),
      createLine({ left: 193, top: 680, width: 409 }),
      createText({
        text: 'Title of Recipient',
        left: 297,
        top: 701,
        fontSize: 16,
        fontFamily: 'Raleway',
        width: 200,
        color: '#080b10'
      }),
      createText({
        text: '{program_description}',
        left: 47,
        top: 746,
        fontSize: 17,
        fontFamily: 'Raleway',
        width: 700,
        color: '#cccccc'
      }),
      createText({
        text: 'Name',
        left: 140,
        top: 883,
        fontSize: 43,
        fontFamily: 'Great Vibes',
        width: 200
      }),
      createLine({ left: 140, top: 939, width: 200 }),
      createText({
        text: 'Name of Issuer',
        left: 140,
        top: 960,
        fontSize: 20,
        fontFamily: 'Raleway',
        width: 200,
        color: '#080b10'
      }),
      createText({
        text: 'Title of Issuer',
        left: 140,
        top: 985,
        fontSize: 15,
        fontFamily: 'Raleway',
        width: 200,
        color: '#999999'
      }),
      createText({
        text: 'Name',
        left: 454,
        top: 883,
        fontSize: 43,
        fontFamily: 'Great Vibes',
        width: 200
      }),
      createLine({ left: 454, top: 939, width: 200 }),
      createText({
        text: 'Name of Issuer',
        left: 454,
        top: 960,
        fontSize: 20,
        fontFamily: 'Raleway',
        width: 200,
        color: '#080b10'
      }),
      createText({
        text: 'Title of Issuer',
        left: 454,
        top: 985,
        fontSize: 15,
        fontFamily: 'Raleway',
        width: 200,
        color: '#999999'
      })
    ],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/08_background.svg',
      key: null
    }
  }
});
